import {createSlice, Dispatch} from '@reduxjs/toolkit';

interface State {
  loading: boolean;
  message: string;
  showMessage: boolean;
  accountSelectorVisible: boolean;
  FindTwoAccount?: boolean;
}
export const initialState: State = {
  loading: false,
  message: '',
  showMessage: false,
  accountSelectorVisible: false,
  FindTwoAccount: false,
};
export const showMessageByAsync = message => (dispatch: Dispatch) => {
  dispatch(showMessage(message));
  setTimeout(() => {
    dispatch(hideMessage());
  }, 5000);
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    showMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideMessage: state => {
      state.message = '';
      state.showMessage = false;
    },
    setFindTwoAccount: (state, action) => {
      state.FindTwoAccount = action.payload;
    },
    showLoading: state => {
      state.loading = true;
    },
    hidLoading: state => {
      state.loading = false;
    },
    showAccountSelector: state => {
      state.accountSelectorVisible = true;
      state.FindTwoAccount = true;
    },
    hideAccountSelector: state => {
      state.accountSelectorVisible = false;
    },
  },
});

export const {showMessage, hideMessage, showLoading, hidLoading, showAccountSelector, hideAccountSelector, setFindTwoAccount} =
  commonSlice.actions;

export default commonSlice.reducer;
